module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-800-6d52788e3081f3ee1e02537184104f9c.jpg";